import axios from 'axios';

import { apiURL } from '../../env.json';
import { getToken } from '../helpers/auth';

export const appInterceptor = () => {
	axios.defaults.baseURL = apiURL;
	axios.interceptors.request.use(
		config => {
			const token = getToken();
			// eslint-disable-next-line @typescript-eslint/no-unused-expressions
			token ? (config.headers.Authorization = `Bearer ${token}`) : null;
			config.headers['Content-Type'] = 'application/json';
			config.headers['Accept'] = 'application/json';
			return config;
		},
		error => {
			return Promise.reject(error);
		}
	);

	axios.interceptors.response.use(
		config => {
			return config;
		},
		async (error) => {
			const originalRequest = error.config;
			const refresh_token = localStorage.getItem('refresh_token');
			if (error.response.status === 401 && refresh_token) {
				try {
					const response = await axios.post(`/auth/refresh`, { refresh_token });
					localStorage.setItem('authToken', response.data.data.access_token)
					return axios.request(originalRequest);
				} catch (e) {
					console.log(e)
				}
			}
			return Promise.reject(error)
		}
	)
};


